import { callUIAPI, isSuccessCode } from './apiUtils';
import { METHOD_GET, METHOD_POST, METHOD_PUT } from './apiUtilsConstants';

export const getContentValidatorModelOptions = async () => {
  try {
    const response = await callUIAPI('bo/content-validators/model-options', {}, METHOD_GET, true);
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('contentValidatorAdminApiUtils.getContentValidatorModelOptions - error:', error);
    throw error;
  }
};

export const getContentValidatorById = async (id) => {
  try {
    const response = await callUIAPI(`bo/content-validators/${id}`, {}, METHOD_GET, true);
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('contentValidatorAdminApiUtils.getContentValidatorById - error:', error);
    throw error;
  }
};

export const createContentValidator = async (input) => {
  try {
    const response = await callUIAPI('bo/content-validators', input, METHOD_POST, true);
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('contentValidatorAdminApiUtils.createContentValidator - error:', error);
    throw error;
  }
};

export const updateContentValidator = async (id, input) => {
  try {
    const response = await callUIAPI(`bo/content-validators/${id}`, input, METHOD_PUT, true);
    if (!isSuccessCode(response.status)) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    console.error('contentValidatorAdminApiUtils.updateContentValidator - error:', error);
    throw error;
  }
};
